import React from 'react';
import PropTypes from 'prop-types';

import { setFieldAndValidate } from '../../../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../../../utils/validation-utils';
import InputWithLabelV2 from '../../../../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';

const EmailControlSet = ({ email, setEmail, liveEmailStatus }) => (
  <>
    <InputWithLabelV2
      id="email"
      label="Email Address"
      type="email"
      autoComplete="email"
      value={email.value}
      maxLength={150}
      placeholder="Enter your email address"
      errorMsg={email.error || liveEmailStatus}
      onChange={({ target: { value } }) => setFieldAndValidate(email, setEmail, value, userFieldSchemas.email)}
    />
  </>
);

EmailControlSet.propTypes = {
  email: PropTypes.object.isRequired,
  setEmail: PropTypes.func.isRequired,
  liveEmailStatus: PropTypes.string.isRequired,
};

export default EmailControlSet;
